import { render, staticRenderFns } from "./SMTasksDetailsRequestSection.vue?vue&type=template&id=7aff2326&scoped=true&"
import script from "./SMTasksDetailsRequestSection.vue?vue&type=script&lang=js&"
export * from "./SMTasksDetailsRequestSection.vue?vue&type=script&lang=js&"
import style0 from "./SMTasksDetailsRequestSection.vue?vue&type=style&index=0&id=7aff2326&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aff2326",
  null
  
)

export default component.exports